import React, { Component } from "react";
import { connect } from "react-redux";
import { getFinancicalSchemas } from "../../../store/actions";
import { withRouter } from "react-router";

import Tables from "./Table";

class FinancicalStructure extends Component {
  async componentDidMount() {
    await this.props.getFinancicalSchemas();
  }

  render() {
    const Schemas = this.props.schemas.financicalSchemas.results;
    return (
      <React.Fragment>
        <Tables schemas={Schemas} />
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return { schemas: state };
}

export default withRouter(
  connect(
    mapStateToProps,
    { getFinancicalSchemas }
  )(FinancicalStructure)
);



// WEBPACK FOOTER //
// ./src/views/FinancicalStructure/FinancicalStructure/FinancicalStructure.js